import { Flex, SkeletonBox, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

export const LoadingSkeleton = (): ReactElement => {
  return (
    <Flex flexDirection="column" gap={Spacing.S24}>
      {Array.from({ length: 3 }).map((_, index) => (
        <Flex key={index} flexDirection="column" gap={Spacing.S14}>
          <SkeletonBox width={250} height={20} />
          <SkeletonBox width={100} height={20} />
        </Flex>
      ))}
    </Flex>
  )
}
